<template>
    <nav class="position-absolute z-index-2 top-0 start-0 d-inline-block navbar navbar-light  w-100 bg-transparent">
        <div class="container d-flex justify-content-end">
            <a class="navbar-brand " href="/" type="button">
                <img :src="require('../../assets/images/logo.svg')" class="logo-size img-fluid" height="70"
                     width="140" alt="LogoNavbar">
            </a>
        </div>
    </nav>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
    name: "navbarChromeWelcome"

})
</script>

<style scoped lang="scss">

.logo-size {
    width: 140px;
    height: 70px;
}
</style>